import React, { useState } from "react";
import Brands from "../../common/Brands/Brands";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import Testimonial from "../../common/Testimonial/Testimonial";
import TeamAbout from "./TeamAbout";
import TeamBanner from "./TeamBanner";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const TeamPage = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <TeamBanner />
      <TeamAbout />
      <Testimonial />
      {/* <Brands /> */}
      <FooterThree />
    </div>
  );
};

export default TeamPage;
